/*
  * Functions to decorate the eSIM card 2 with loaded eSIM data
  *
  * See order-confirmation-popup.liquid for reference.
  */

/*
* Insert the QR code into the order popup
*/
function insertQrIntoOrderPopup(order_popup, esim_info) {
  order_popup.querySelector('#confirmation-qrcode').innerHTML = `<img src=${esim_info.qrUrl()} loading="lazy" width="auto" height="auto">`;
}

/*
* Insert the typename of the eSIM into the order popup
*/
function insertTypeNameIntoOrderPopup(order_popup, esim_info) {
  order_popup.querySelector('#confirmation-esim-name').textContent = stripDataInfoFromProductName(esim_info.productName) + ' eSIM';
}

/*
* Add share button functionality to the order popup
*/
function addShareFunctionalityIntoOrderPopup(order_popup, esim_info) {
  let share_button = order_popup.querySelector('.share_button');
  let share_text = order_popup.querySelector('.confirmation-share-text');

  if (!share_button) {
    share_button.style.display = 'none';
    share_text.style.display = 'none';

    return;
  }

  share_button.addEventListener('click', () => {
    shareEsimQrCode(esim_info.qrUrl(), esim_info.iccid);
  });
}

/*
* Add "add another esim" button functionality to the order popup
*/
function insertAddAnotherEsimButton(order_popup) {
  order_popup.querySelector('.add_another_esim_button').addEventListener('click', () => {
    window.location = Shopify.routes.root;
  });
}

/*
* Add "Install eSIM" button functionality to the order popup
*/
function insertInstallEsimButton(order_popup, esim_info) {
  order_popup.querySelector('.install_esim_button').addEventListener('click', function(evt) {
    if (esim_info.isLegacy === false) {
      openEsimInstall(esim_info, null, null, 'setupGuide');
    } else {
      openEsimInstall(esim_info.ref, esim_info.token, esim_info.iccid, 'setupGuide');
    }
  });

  let install_link_text_button = order_popup.querySelector('#install_esim_link_text');

  if (install_link_text_button) {
    install_link_text_button.addEventListener('click', function(evt) {
      if (esim_info.isLegacy === false) {
        openEsimInstall(esim_info, null, null, 'setupGuide');
      } else {
        openEsimInstall(esim_info.ref, esim_info.token, esim_info.iccid, 'setupGuide');
      }
    });
  }
}
